var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTarget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_32_1",
    "data-name": "Component 32 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3343",
    "data-name": "Rectangle 3343",
    width: 16,
    height: 16,
    transform: "translate(0.25)",
    fill: "#8a8a8a",
    stroke: "#8a8a8a",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_196",
    "data-name": "Mask Group 196",
    transform: "translate(-0.25)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "__TEMP__SVG__",
    d: "M8.381,6a2.381,2.381,0,1,0,2.381,2.381A2.388,2.388,0,0,0,8.381,6Zm5.683,1.746A5.736,5.736,0,0,0,9.016,2.7V1.714H7.746V2.7A5.736,5.736,0,0,0,2.7,7.746H1.714v1.27H2.7a5.736,5.736,0,0,0,5.048,5.048v.984h1.27v-.984a5.736,5.736,0,0,0,5.048-5.048h.984V7.746ZM8.381,12.825a4.444,4.444,0,1,1,4.444-4.444A4.458,4.458,0,0,1,8.381,12.825Z",
    transform: "translate(-0.297 -0.381)",
    fill: "#8a8a8a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/target.5b8ab68fdcf0d102382e887c639acb65.svg";
export { ForwardRef as ReactComponent };